import React from 'react';

export default class Link extends React.Component {

  state = {
    showPopOver: false
  };

  openLink = () => {
    const { entityKey, contentState } = this.props;
    const { url } = contentState.getEntity(entityKey).getData();
    const linkTab = window.open(url, 'blank'); // eslint-disable-line no-undef
    linkTab.focus();
  }

  toggleShowPopOver = () => {
    const showPopOver = !this.state.showPopOver;
    this.setState({
      showPopOver,
    });
  }

  render() {
    const { children, entityKey, contentState } = this.props;
    const { url, target } = contentState.getEntity(entityKey).getData();

    return (
      <span
        className="rdw-link-decorator-wrapper"
      >
          <a href={url} target={target}>{children}</a>
        </span>
    );
  }
};



// WEBPACK FOOTER //
// ./src/blocks/Link.jsx